/**
 * @generated SignedSource<<a9f5b61e473acfc5c00cfcc56ae8698f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { Result } from "relay-runtime";
export type backofficeUiPreferencesReadQuery$variables = Record<PropertyKey, never>;
export type backofficeUiPreferencesReadQuery$data = {
  readonly backofficeUiPreference: Result<{
    readonly data: string;
  } | null, unknown>;
};
export type backofficeUiPreferencesReadQuery = {
  response: backofficeUiPreferencesReadQuery$data;
  variables: backofficeUiPreferencesReadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "BackofficeUiPreferenceApiDto",
  "kind": "LinkedField",
  "name": "backofficeUiPreference",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "data",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "backofficeUiPreferencesReadQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": (v0/*:: as any*/),
        "to": "RESULT"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "backofficeUiPreferencesReadQuery",
    "selections": [
      (v0/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "50e6eb72c67096cb84178d19a7f0a2e1",
    "id": null,
    "metadata": {},
    "name": "backofficeUiPreferencesReadQuery",
    "operationKind": "query",
    "text": "query backofficeUiPreferencesReadQuery {\n  backofficeUiPreference {\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "32a0a39ca1299d437b1d0a07664d2a33";

export default node;
